import { Button, ClickAwayListener, Fade, Paper, Popper } from '@mui/material';
import type { Filter } from '@niarab2c/frontend-commons/src/types/hotels';
import { FILTER_TITLES } from '@niarab2c/niarab2c-core/src/util/constants';
import React, { useCallback, useState } from 'react';
import { MdManageSearch } from 'react-icons/md';
import { HotelCategoryFilter } from '../../../components';
import * as S from './styles';
interface AdvancedFiltersProps {
  filters: Partial<Filter>;
  setFilters: React.Dispatch<React.SetStateAction<Partial<Filter>>>;
}
const AdvancedFilters: React.FC<AdvancedFiltersProps> = ({
  filters,
  setFilters
}) => {
  const [showPopper, setShowPopper] = useState(false);
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const [arrowElement, setArrowElement] = useState<HTMLDivElement | null>(null);
  const handleAdvancedFiltersClick = useCallback((event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
    setShowPopper(oldShowPopper => !oldShowPopper);
  }, []);
  const handleClosed = useCallback(() => {
    setShowPopper(false);
    setAnchorEl(null);
  }, []);
  return <>
      <S.ButtonContainer>
        <Button sx={{
        position: 'relative'
      }} variant="text" color="primary" size="small" startIcon={<MdManageSearch />} onClick={handleAdvancedFiltersClick}>
          Pesquisa avançada
        </Button>
      </S.ButtonContainer>
      <Popper open={showPopper} anchorEl={anchorEl} placement={'bottom-end'} transition disablePortal={true} style={{
      zIndex: 1300
    }} modifiers={[{
      name: 'offset',
      options: {
        offset: [0, 8]
      }
    }, {
      name: 'flip',
      enabled: true,
      options: {
        altBoundary: true,
        fallbackPlacements: ['bottom', 'bottom-start', 'bottom-end']
      }
    }, {
      name: 'preventOverflow',
      enabled: true,
      options: {
        altAxis: true,
        padding: 8
      }
    }, {
      name: 'arrow',
      enabled: true,
      options: {
        element: arrowElement,
        padding: 8
      }
    }, {
      name: 'computeStyles',
      options: {
        gpuAcceleration: false,
        adaptive: true
      }
    }]}>
        {({
        TransitionProps
      }) => <Fade {...TransitionProps} timeout={350}>
            <Paper style={{
          position: 'relative',
          overflow: 'visible',
          marginTop: 8,
          padding: 10
        }}>
              <ClickAwayListener onClickAway={handleClosed}>
                <div>
                  <S.ArrowPopper ref={setArrowElement} data-popper-arrow />
                  <HotelCategoryFilter title={FILTER_TITLES['award']} filter={filters} filterKey={'award'} setFilter={setFilters} />
                </div>
              </ClickAwayListener>
            </Paper>
          </Fade>}
      </Popper>
    </>;
};
export default AdvancedFilters;